import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AddressAddDialogComponent } from '@features/address/components/address-add-dialog/address-add-dialog.component';
import { AddressEditDialogComponent } from '@features/address/components/address-edit-dialog/address-edit-dialog.component';
import { UserAddress } from '@features/address/interfaces/user-address.interface';
import { AddressService } from '@features/address/services/address.service';
import { User } from '@features/user/interfaces/user.interface';
import { ChangePasswordService } from '@features/user/services/change-password.service';
import { UserService } from '@features/user/services/user.service';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import {
  faEye,
  faEyeSlash,
  faMagnifyingGlass,
  faPlus,
  faSpinner,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutService } from 'src/app/layout/services/layout.service';

interface Identity {
  name: string | number;
  value: string | number;
}
@Component({
  selector: 'fc-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  file: any = {
    file: null,
    src: null,
  };

  faMagnifyingGlass = faMagnifyingGlass;
  faPenToSquare = faPenToSquare;
  faEyeSlash = faEyeSlash;
  faEye = faEye;
  faTrash = faTrash;
  faSpinner = faSpinner;
  faPlus = faPlus;

  gender!: Identity[];
  date: Identity[];
  month: Identity[];
  year: Identity[] = [];
  selectedDate!: Identity;
  selectedMonth!: Identity;
  selectedYear!: Identity;

  user?: User;
  addresses: UserAddress[] = [];
  profileForm: FormGroup;
  changePasswordForm: FormGroup;
  loading = false;
  loadingProfile = false;
  loadingPhotoProfile = false;
  selectedFile: File = {} as File;
  checkFileSize?: boolean;
  checkFileType?: boolean;

  constructor(
    private userService: UserService,
    private addressService: AddressService,
    private changePasswordService: ChangePasswordService,
    private dialogService: DialogService,
    private sanitizer: DomSanitizer,
    private layoutService: LayoutService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Profil Saya',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }

    this.changePasswordForm = new FormGroup({
      old_password: new FormControl(null, Validators.required),
      new_password: new FormControl(null, Validators.required),
      new_password_confirmation: new FormControl(null, Validators.required),
    });
    this.profileForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      gender: new FormControl(null, Validators.required),
      phone_number: new FormControl(null, Validators.required),
      date_of_birth_day: new FormControl(null, Validators.required),
      date_of_birth_month: new FormControl(null, Validators.required),
      date_of_birth_year: new FormControl(null, Validators.required),
    });
    this.date = [
      { name: '1', value: 1 },
      { name: '2', value: 2 },
      { name: '3', value: 3 },
      { name: '4', value: 4 },
      { name: '5', value: 5 },
      { name: '6', value: 6 },
      { name: '7', value: 7 },
      { name: '8', value: 8 },
      { name: '9', value: 9 },
      { name: '10', value: 10 },
      { name: '11', value: 11 },
      { name: '12', value: 12 },
      { name: '13', value: 13 },
      { name: '14', value: 14 },
      { name: '15', value: 15 },
      { name: '16', value: 16 },
      { name: '17', value: 17 },
      { name: '18', value: 18 },
      { name: '19', value: 19 },
      { name: '20', value: 20 },
      { name: '21', value: 21 },
      { name: '22', value: 22 },
      { name: '23', value: 23 },
      { name: '24', value: 24 },
      { name: '25', value: 25 },
      { name: '26', value: 26 },
      { name: '27', value: 27 },
      { name: '28', value: 28 },
      { name: '29', value: 29 },
      { name: '30', value: 30 },
      { name: '31', value: 31 },
    ];
    this.month = [
      { name: 'January', value: 1 },
      { name: 'February', value: 2 },
      { name: 'March', value: 3 },
      { name: 'April', value: 4 },
      { name: 'May', value: 5 },
      { name: 'June', value: 6 },
      { name: 'July', value: 7 },
      { name: 'August', value: 8 },
      { name: 'September', value: 9 },
      { name: 'October', value: 10 },
      { name: 'November', value: 11 },
      { name: 'December', value: 12 },
    ];
    // populate year dropdown
    for (let index = 1950; index <= new Date().getFullYear(); index++) {
      this.year.push({ name: index, value: index });
    }
    this.gender = [
      { name: 'Pria', value: 0 },
      { name: 'Wanita', value: 1 },
    ];
    this.userService.currentUserValue.subscribe((user) => {
      this.user = user;
    });
    this.profileForm.patchValue({
      name: this.user?.name,
      gender: this.user?.gender,
      date_of_birth_day: this.user?.date_of_birth_day,
      date_of_birth_month: this.user?.date_of_birth_month,
      date_of_birth_year: this.user?.date_of_birth_year,
    });
  }
  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  ngOnInit(): void {
    this.getAddressList();
  }

  display: boolean = false;

  showAddress() {
    this.display = true;
  }

  updateProfile() {
    this.loadingProfile = true;
    this.userService
      .updateUserProfile(this.profileForm.value)
      .subscribe((res: any) => {
        alert('Data Berhasil Diubah');
        this.loadingProfile = false;
      });
  }

  onAddAddress() {
    const ref = this.dialogService.open(AddressAddDialogComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      width: '500px',
      contentStyle: {
        padding: '0',
      },
      style: {
        'border-radius': '1rem',
        overflow: 'hidden',
      },
    });
  }

  onEditAddress(address: any) {
    const ref = this.dialogService.open(AddressEditDialogComponent, {
      data: {
        address: address,
      },
      dismissableMask: true,
      closable: true,
      showHeader: false,
      width: '500px',
      contentStyle: {
        padding: '0',
      },
      style: {
        'border-radius': '1rem',
        overflow: 'hidden',
      },
    });
    ref.onClose.subscribe((isUpdated: boolean) => {
      if (isUpdated) {
        this.getAddressList();
      }
    });
  }

  getAddressList() {
    this.addressService.getAddresses().subscribe((data) => {
      this.addresses = data;
    });
  }

  removeAddress(id: string) {
    if (confirm('Apakah kamu yakin ingin menghapusnya ?')) {
      this.addressService.deleteAddress(id).subscribe(() => {
        alert('Berhasil Menghapus');
      });
    }
  }

  changePassword() {
    this.loading = true;
    if (
      this.changePasswordForm.value.new_password !==
      this.changePasswordForm.value.new_password_confirmation
    ) {
      this.loading = true;
      setTimeout(() => {
        alert('Password Tidak Sama');
        this.loading = false;
      }, 1000);
    } else {
      this.loading = true;
      this.changePasswordService
        .changePassword(this.changePasswordForm.value)
        .subscribe(() => {
          this.loading = false;
          alert('Password Berhasil Diubah');
          this.changePasswordForm.reset();
        });
    }
  }

  onImageChangeFromFile($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      let file = $event.target.files[0];
      this.selectedFile = file;
      this.checkFileSize = file.type;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_e: any) => {
        let sanitizedImg = this.sanitizer.bypassSecurityTrustUrl(
          reader.result as string
        );
        this.file = { file: file, src: sanitizedImg };
      };
      if (
        (file.type === 'image/jpeg' || file.type === 'image/png') &&
        file.size < 2000000
      ) {
        this.checkFileType = true;
        this.checkFileSize = true;
      } else {
        this.checkFileType = false;
        this.checkFileSize = false;
      }
    }
    if (this.checkFileType) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);
      this.loadingPhotoProfile = true;
      this.userService.updatePhotoProfile(formData).subscribe((res: any) => {
        alert('Upload Foto Berhasil');
        this.loadingPhotoProfile = false;
      });
    } else {
      alert('Format file tidak sesuai.');
      this.loadingPhotoProfile = false;
    }
  }
}
